import React from 'react';

const ArcThree = ({
  fill = 'white',
  stroke = 'rgba(240, 0, 55, 0.06)',
  strokeWidth = 1,
  className = '',
}) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="185"
        height="40"
        viewBox="0 0 185 40"
        fill="none"
        className={className}

      >
        <path
          d="M181.017 1.11874C185.116 2.93778 185.717 8.45269 181.928 10.8502C160.389 24.4777 131.844 33.8697 100.323 37.5737C67.5231 41.4279 33.5234 38.8854 3.60891 30.4284C-0.0515581 29.3935 -1.17546 24.8409 1.48425 22.1214C3.41807 20.1441 6.30135 19.4468 8.95133 20.2386C35.9057 28.2921 66.8678 30.8003 96.7021 27.2946C125.707 23.8863 151.847 15.0052 171.071 2.11269C174.02 0.134534 177.771 -0.321913 181.017 1.11874Z"
          fill={fill}
          stroke={stroke}
          style={{
            mixBlendMode: 'multiply',
            filter: 'blur(1px)',
          }}

        />
        <path
          d="M171.349 2.5283C174.08 0.69664 177.516 0.238555 180.525 1.45311L180.814 1.57616C184.463 3.19564 185.048 7.95295 181.97 10.2168L181.661 10.4277C160.533 23.7948 132.617 33.0857 101.738 36.8994L100.265 37.0771C68.0383 40.864 34.653 38.4636 5.14705 30.3389L3.74471 29.9472C0.568161 29.0491 -0.498017 25.1836 1.62654 22.706L1.84138 22.4707C3.58425 20.6886 6.16205 20.0193 8.57478 20.6523L8.80818 20.7178C35.4096 28.6658 65.894 31.2241 95.358 27.9512L96.7603 27.791C125.37 24.4292 151.225 15.7512 170.439 3.13182L171.349 2.5283Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeOpacity="0.06"
        />
      </svg>
    </div>
  );
};

export default ArcThree;
